import React, { useEffect, useState } from 'react';

import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Modal, Popconfirm, Spin, Table, message } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import sessionManager, { eVariableType } from '../../SessionManager';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';
import { ViaggioDettaglioModel } from '../Models/CRMViaggiModels';
import ViaggioAddEdit from './ViaggioAddEdit';
import ViaggioDettagliAddEdit from './ViaggioDettagliAddEdit';

interface ViaggioDettaglioProps {
    idViaggio: number | null;
}

export default function ViaggioDettagli(props: ViaggioDettaglioProps) {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<ViaggioDettaglioModel[]>();
    const [viaggioDettaglioSelected, setViaggioDettaglioSelected] = useState<ViaggioDettaglioModel | null>(null);
    const [openViaggioDettaglioAddEdit, setOpenViaggioDettaglioAddEdit] = useState(false);
    const [confirm, setConfirm] = useState(false);

    async function Load() {
        try {
            const res = await api.get(
                'CRM/Viaggi/Dettagli?idViaggio=' +
                    props.idViaggio +
                    '&idSocieta=' +
                    sessionManager.get(eVariableType.IDSocieta)
            );
            if (res !== null) {
                setData(res.data);
            }
        } catch (error) {
            GetErrorMessage(error);
        }
    }

    useEffect(() => {
        Load();
    }, [props.idViaggio]);

    function onClickNew() {
        setViaggioDettaglioSelected(null);
        setOpenViaggioDettaglioAddEdit(true);
    }

    const cols: ColumnsType<any> = [
        {
            title: stringres.t('codCliente').toString(),
            dataIndex: 'codCliente',
            width: '100px',
        },
        {
            title: stringres.t('ragioneSociale').toString(),
            dataIndex: 'ragioneSociale',
            width: '400px',
        },
        {
            title: stringres.t('data').toString(),
            dataIndex: 'data',
            width: '100px',
        },
        {
            title: stringres.t('descrizione').toString(),
            dataIndex: 'descrizione',
        },
        {
            title: '',
            dataIndex: '',
            width: 50,
            render: (record) => <Button icon={<EditOutlined />} onClick={() => onedit(record)}></Button>,
        },
        {
            title: '',
            width: 50,
            render: (record) => (
                <Popconfirm
                    title={stringres.t('elimina').toString()}
                    description={stringres.t('eliminare?').toString()}
                    onConfirm={() => onDelete(record)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button icon={<DeleteOutlined />}></Button>
                </Popconfirm>
            ),
        },
    ];

    async function onedit(record) {
        const x: ViaggioDettaglioModel = record;

        setViaggioDettaglioSelected(x);
        setOpenViaggioDettaglioAddEdit(true);
    }

    async function onDelete(rec: any) {
        try {
            setIsLoading(true);
            if (rec != null) {
                const result = await api.delete(
                    'CRM/Viaggi/Dettagli/Delete?idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&idViaggio=' +
                        rec.idViaggio +
                        '&numRiga=' +
                        rec.numRiga
                );
                if (result.status === 200) {
                    message.success(stringres.t('successo').toString());

                    Load();
                } else message.error(result.statusText);
            }
        } catch (error) {
            GetErrorMessage(error);
        } finally {
            setIsLoading(false);
        }
    }

    function onClose(esito: boolean) {
        setOpenViaggioDettaglioAddEdit(false);
        if (esito) {
            message.success(stringres.t('successo').toString());

            Load();
        }
    }

    return (
        <div>
            <Spin spinning={isLoading}>
                <div style={{ display: 'flex' }}>
                    <ViaggioAddEdit
                        width="450px"
                        idViaggio={props.idViaggio}
                        onClose={() => {
                            return;
                        }}
                    ></ViaggioAddEdit>
                </div>
                <Card
                    title={stringres.t('dettagliodativiaggio').toString()}
                    extra={
                        <Button onClick={onClickNew}>
                            <PlusOutlined />
                        </Button>
                    }
                >
                    <Table scroll={{ x: 'max-content' }} rowKey="numRiga" columns={cols} dataSource={data}></Table>
                </Card>
                <Modal
                    title={stringres.t('dettagliodativiaggio').toString()}
                    open={openViaggioDettaglioAddEdit}
                    width="50%"
                    style={{ minWidth: '350px' }}
                    onCancel={() => setOpenViaggioDettaglioAddEdit(false)}
                    onOk={() => setConfirm(!confirm)}
                    footer={null}
                    destroyOnClose={true}
                >
                    <div style={{ marginTop: '30px' }}>
                        <ViaggioDettagliAddEdit
                            idViaggio={props.idViaggio}
                            close={onClose}
                            viaggioDettaglio={viaggioDettaglioSelected}
                            confirm={confirm}
                        ></ViaggioDettagliAddEdit>
                    </div>
                </Modal>
            </Spin>
        </div>
    );
}
